import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {RouteHelper} from "../../../route/RouteHelper";
import GroupDetailInfo from "./GroupDetailInfo";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import GroupDetailUsers from "./GroupDetailUsers";
import GroupDetailReport from "./GroupDetailReport";

export default function GroupDetail() {
    const {state: location} = useLocation()
    const navigate = useNavigate()

    const [pageTitle, setPageTitle] = useState()

    useEffect(() => {
        if (location && location.title) {
            setPageTitle(location.title)
        }
    }, [location]);

    const [selectedTab, setSelectedTab] = useState(tabInfo.BASIC_INFO.id)

    const handleChangeTabMenu = (event, newValue) => {
        setSelectedTab(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.GroupsList.name,
                        RouteHelper.GroupsList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>

            <TabContext value={selectedTab}>
                <TabBoxContainer>
                    <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                        <Tab
                            label={tabInfo.BASIC_INFO.title}
                            value={tabInfo.BASIC_INFO.id}/>
                        <Tab
                            label={tabInfo.USERS.title}
                            value={tabInfo.USERS.id}/>
                        <Tab
                            label={tabInfo.REPORTS.title}
                            value={tabInfo.REPORTS.id}/>
                    </TabList>
                </TabBoxContainer>

                <TabPanel value={tabInfo.BASIC_INFO.id}>
                    <GroupDetailInfo/>
                </TabPanel>
                <TabPanel value={tabInfo.USERS.id}>
                    <GroupDetailUsers/>
                </TabPanel>
                <TabPanel value={tabInfo.REPORTS.id}>
                    <GroupDetailReport
                        groupName={pageTitle}
                    />
                </TabPanel>

            </TabContext>

        </RaikoBaseContainer>
    )
}

const tabInfo = {
    BASIC_INFO: {
        id: "BASIC_INFO",
        title: "اطلاعات پایه"
    }, USERS: {
        id: "USERS",
        title: "اعضا گروه"
    }, REPORTS: {
        id: "REPORTS",
        title: "گزارشات"
    },
}
